const AUTHENTICATED = "authenticated"
const UNAUTHENTICATED = "unauthenticated"
const LOADING = "loading"

export {
    AUTHENTICATED,
    UNAUTHENTICATED,
    LOADING,
}